module.exports = __webpack_public_path__ + "img/close.67f12fc9.png";